import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { CheckCircleOutlined, CheckCircleFilled } from "@ant-design/icons";
type Props = {
  open: boolean;
  onClose: () => void;
  heading: string;
  content: React.ReactNode;
  icon?: React.ReactNode;
};
const AuthPopup = ({
  heading = "Thiết lập mật khẩu thành công",
  content,
  icon = <CheckCircleFilled style={{ fontSize: "28px", color: "#66CD15" }} />,
  open,
  onClose,
}: Props) => {
  return open ? (
    <div className="auth_popup_wrapper">
      <div className="auth_popup_body">
        <span className="auth_popup_body_close" onClick={onClose}>
          <CloseOutlined />
        </span>
        {icon}
        <div className="auth_popup_body_heading">{heading}</div>
        <div className="auth_popup_body_content">{content}</div>
      </div>
      {/* <CheckCircleOutlined /> */}
    </div>
  ) : null;
};

export default AuthPopup;
